import {
  Organisation,
  CreateOrganisationDto,
  UpdateOrganisationDto,
} from "@/types";
import { axiosInstance } from "@/lib/axios";

export interface GetOrganisationsParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
}

export interface GetOrganisationsResponse {
  data: Organisation[];
  count: number;
}

/**
 * Get all organisations with pagination
 */
export const getOrganisations = async (
  params?: GetOrganisationsParams
): Promise<GetOrganisationsResponse> => {
  const response = await axiosInstance.get<GetOrganisationsResponse>(
    "/organisations",
    {
      params,
    }
  );
  return response.data;
};

/**
 * Get a single organisation by ID
 */
export const getOrganisationById = async (
  id: string
): Promise<Organisation> => {
  const response = await axiosInstance.get<Organisation>(
    `/organisations/${id}`
  );
  return response.data;
};

/**
 * Create a new organisation
 */
export const createOrganisation = async (
  data: CreateOrganisationDto
): Promise<Organisation> => {
  const response = await axiosInstance.post<Organisation>(
    "/organisations",
    data
  );
  return response.data;
};

/**
 * Update an existing organisation
 */
export const updateOrganisation = async (
  id: string,
  data: UpdateOrganisationDto
): Promise<Organisation> => {
  const response = await axiosInstance.patch<Organisation>(
    `/organisations/${id}`,
    data
  );
  return response.data;
};

/**
 * Delete an organisation
 */
export const deleteOrganisation = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/organisations/${id}`);
};
